import React, {Component} from 'react';
import PropTypes from 'prop-types';
import IconButton from 'material-ui/IconButton';
import ActionSave from 'material-ui/svg-icons/content/save';
import ActionCopy from 'material-ui/svg-icons/content/content-copy';
import ActionPaste from 'material-ui/svg-icons/content/content-paste';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Toggle from 'material-ui/Toggle';
import {DivHeaderActions, DivTitle, DivContent } from './styled';
import Paper from 'material-ui/Paper';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import { DialogIconTemplate, TextInput, Alignment, BlockCounter } from './components';
import {SketchColorPicker}  from '../../../components';
 

class IconButtonView extends Component{
  constructor(props){
    super(props);
    const { buttonColors, tooltipPosition, tooltip, icon, size, href, buttonAlign , disabled, containerPadding} = props.data.values;
    this.state = {
      expanded: true,
      buttonColors, 
      tooltipPosition, 
      tooltip, 
      icon, 
      size, 
      href, 
      buttonAlign, 
      disabled, 
      containerPadding,
      disabledTooltip: (tooltip.length > 0) ? false: true  ,
    }
  }
  handleExpandChange = (expanded) => {
    this.setState({expanded: expanded});
  }
  onUpdateTooltip = (value) => {
    this.setState({
      tooltip: value,
    });
  }
  onUpdateUrl = (value) => {
    let newHref = this.state.href;
    newHref.url = value;
    
    this.setState({
      href: newHref,
    });
  }
  onItemSelected = (value) => {
    this.setState({
      icon: value,
    });
  }  
  
  onChangeButtonAlign = (value) => {
    this.setState({
      buttonAlign: value,
    });
  }
  onToggleDisabled = (e,v) => {
    this.setState({disabled:v});
  }
  onToggleDisabledToolTip = (e,v) => {
    if(v){
      this.setState({disabledTooltip:v, tooltip:''});
    }else{
      this.setState({disabledTooltip:v});
    }
  } 
  onChangeTarget = (event, index, value) => {
    const newValue = (value === '_blank') ? value : '';
    let newHref = this.state.href;
    newHref.target = newValue;
    this.setState({
      href: newHref,
    });
  }
  onChangeTooltipPosition = (event, index, value) => {
    this.setState({
      tooltipPosition: value,
    });
  }
  onChangeSize = (event, index, value) => {
    this.setState({
      size: value,
    });
  }
  onUpdatePadding = (padding) => {
    this.setState({containerPadding:padding});
  }
  onUpdateColor = (color, type ) => {
    let newButtonColor = this.state.buttonColors;
    if(type === 'color'){
      newButtonColor.color = color;  
    } else if(type === 'background'){
      newButtonColor.backgroundColor = color;  
    } else if(type === 'hover'){
      newButtonColor.hoverColor = color;
    } 
    this.setState({
      buttonColors: newButtonColor,
    });
  }
  
  onClickCopy = () => {
    let newData = this.props.data;
    newData.values.tooltip = this.state.tooltip;
    newData.values.containerPadding = this.state.containerPadding;
    newData.values.buttonAlign = this.state.buttonAlign;
    newData.values.buttonColors = this.state.buttonColors;
    newData.values.tooltipPosition = this.state.tooltipPosition;
    newData.values.icon = this.state.icon;
    newData.values.disabled = this.state.disabled;
    newData.values.href = this.state.href;
    newData.values.size = this.state.size;
    localStorage.setItem('IconButtonView', JSON.stringify(newData.values));
  }
  onClickPaste = () => {
    const IconContent = JSON.parse(localStorage.getItem('IconButtonView'));
    if(IconContent){
      const { buttonColors, tooltipPosition, tooltip, icon, size, href, buttonAlign , disabled, containerPadding} = IconContent;
      this.setState({
        buttonColors, 
        tooltipPosition, 
        tooltip, 
        icon, 
        size, 
        href, 
        buttonAlign, 
        disabled, 
        containerPadding
      });
    }
  }
  onClickSave = () => {
    let newData = this.props.data;
    newData.values.tooltip = this.state.tooltip;
    newData.values.containerPadding = this.state.containerPadding;
    newData.values.buttonAlign = this.state.buttonAlign;
    newData.values.buttonColors = this.state.buttonColors;
    newData.values.tooltipPosition = this.state.tooltipPosition;
    newData.values.icon = this.state.icon;
    newData.values.disabled = this.state.disabled;
    newData.values.href = this.state.href;
    newData.values.size = this.state.size;
    //  console.log(newData.values);
    this.props.onUpdateData(newData);
  }
  render(){
    const {target} = this.state.href;
    const valueTarget = (target === '_blank') ? target : 'same';
    return(
      <div style={{width:'100%'}}>
        <div style={styles.paperCard}>
          <Card expanded={this.state.expanded} onExpandChange={this.handleExpandChange}> >
            <CardHeader
              title="General"
              subtitle="Content Icon Button"
              actAsExpander={true}
              showExpandableButton={true}
              style={styles.headerCard}
            />
            <CardText expandable={true} style={{ overflowY: "scroll", height: 500 }}>
              <Paper style={styles.paperText} zDepth={1}>
                <div>
                  <Toggle
                    label="Disabled Icon Button"
                    style={{marginBottom:10}}
                    toggled={this.state.disabled}
                    onToggle={(e,v) =>this.onToggleDisabled(e,v)}
                  />
                </div>

                <DivTitle>ToolTip</DivTitle>
                <Toggle
                    label="Disabled Tooltip"
                    style={{marginBottom:10}}
                    toggled={this.state.disabledTooltip}
                    onToggle={(e,v) =>this.onToggleDisabledToolTip(e,v)}
                  />
                {(!this.state.disabledTooltip) && <div>
                <TextInput value={this.state.tooltip} onChange={(value) => this.onUpdateTooltip(value)} name="textButton" title="" fullWidth={true} />
                <SelectField floatingLabelText="Tooltip Position" onChange={(event, index, value) => this.onChangeTooltipPosition(event, index, value)} value={this.state.tooltipPosition} autoWidth={true} name="tooltipposition" >
                  <MenuItem value={'top-left'} primaryText="Top Left" />
                  <MenuItem value={'top-right'} primaryText="Top Right" />
                  <MenuItem value={'top-center'} primaryText="Top Center" />
                  <MenuItem value={'bottom-left'} primaryText="Bottom Left" />
                  <MenuItem value={'bottom-right'} primaryText="Bottom Right" />
                  <MenuItem value={'bottom-center'} primaryText="Bottom Center" />
                </SelectField></div>}
              </Paper>
              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Size Icon Button</DivTitle>
                <SelectField floatingLabelText="" onChange={(event, index, value) => this.onChangeSize(event, index, value)} value={this.state.size} autoWidth={true} name="size" >
                  <MenuItem value={'xsmall'} primaryText="X-Small" />
                  <MenuItem value={'small'} primaryText="Small" />
                  <MenuItem value={'medium'} primaryText="Medium" />
                  <MenuItem value={'large'} primaryText="Large" />
                </SelectField>
              </Paper>
              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Button Align</DivTitle>
                <Alignment value={this.state.buttonAlign} onChange={(value) => this.onChangeButtonAlign(value)} title=""/>
              </Paper>
              <Paper style={{padding:10, marginBottom:10}} zDepth={1}>
                <DivTitle>Button Color</DivTitle>
                <DivContent>
                  <SketchColorPicker title={'Color'} onUpdateColor={(color) => this.onUpdateColor(color, 'color')} color={this.state.buttonColors.color}/>
                  <SketchColorPicker title={'Background'} onUpdateColor={(color) => this.onUpdateColor(color, 'background')} color={this.state.buttonColors.backgroundColor}/>
                  <SketchColorPicker title={'Hover'} onUpdateColor={(color) => this.onUpdateColor(color, 'hover')} color={this.state.buttonColors.hoverColor}/>
                </DivContent>
              </Paper>
              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Action</DivTitle>
                <TextInput value={this.state.href.url} onChange={(value) => this.onUpdateUrl(value)} name="HrefUrl" title="Url" fullWidth={true}/>
                <SelectField floatingLabelText="Target" onChange={(event, index, value) => this.onChangeTarget(event, index, value)} value={valueTarget} autoWidth={true} name="target href" >
                  <MenuItem value={'same'} primaryText="Same Page" />
                  <MenuItem value={'_blank'} primaryText="New Page" />
                </SelectField>
              </Paper>
              <Paper style={styles.paperText} zDepth={1}>
                <DialogIconTemplate iconItem={this.state.icon} onItemSelected={(icon) => {this.onItemSelected(icon)}} isRequired={true} />
              </Paper>
              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Container Padding</DivTitle>
                <BlockCounter containerPadding={this.state.containerPadding} onUpdatePadding={(containerPadding) => this.onUpdatePadding(containerPadding)}  />
              </Paper>
            </CardText>
          </Card>
        </div>
        <DivHeaderActions>
          <IconButton onClick={this.onClickCopy} iconStyle={{color:'#FFFFFF'}} >
            <ActionCopy/>
          </IconButton>
          <IconButton onClick={this.onClickPaste} iconStyle={{color:'#FFFFFF'}} >
            <ActionPaste/>
          </IconButton>
          <IconButton onClick={this.onClickSave} iconStyle={{color:'#FFFFFF'}} >
            <ActionSave/>
          </IconButton>
        </DivHeaderActions>
      </div>
    )
  }
}
 

const styles = {
  paper: {
    margin:10,
    padding:10
  },
  headerCard: {
    display:'flex',
    textAlign:'left'
  },
  paperCard:{
    margin:10
  },
  paperText: {
    padding:10,
    marginBottom:10
  },
  customWidth: {
    width: 150,
  },
  block: {
    maxWidth: 250,
  },
  radioButton: {
    width: 136
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent:'flex-start',
    flex: '1 auto'
  }
}

IconButtonView.propTypes = {
  data: PropTypes.object,
  onUpdateData : PropTypes.func.isRequired
};

IconButtonView.defaultProps = {
  data:{}
};
export default IconButtonView;



// WEBPACK FOOTER //
// ./src/editor/layout/addons/props/IconButtonView.js